import React from 'react'
import "./Choose_us.css";
import Common_heading from '../../Common_Component/Common_heading/Common_heading';

export default function Choose_us() {
    return (
        <section className='home_chooseus'>
            <div className='container'>
                <Common_heading headingText={"Why Choose Us?"} />
                <h6>We offer a compelling solution for those seeking extra income without sacrificing their precious time and freedom.</h6>
                <div className='row cards'>
                    <div className=' col-lg-3 col-md-3 col-sm-6 col-10 mx-auto card-info'>
                        <div className='content'>
                            <div className='head'>
                                <p>A Proven<br />Business Model</p>
                                <h1>1</h1>
                            </div>
                            <div className='para'>
                                Leverage a successful system with
                                established products services and
                                a supportive network.
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-3 col-sm-6 col-10 mx-auto card-info'>
                        <div className='content'>
                            <div className='head'>
                                <p>Low<br /> Start-Up Costs</p>
                                <h1>2</h1>
                            </div>
                            <div className='para'>
                                Begin building your business with a
                                minimal investment compared to
                                traditional business ventures.
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-3 col-sm-6 col-10 mx-auto card-info'>
                        <div className='content'>
                            <div className='head'>
                                <p>Low<br /> Start-Up Costs</p>
                                <h1>3</h1>
                            </div>
                            <div className='para'>
                                Your income is directly tied to your
                                efforts. The more you put in, the
                                more you can earn.
                            </div>
                        </div>
                    </div>
                    <div className=' col-lg-3 col-md-3 col-sm-6 col-10 mx-auto card-info'>
                        <div className='content'>
                            <div className='head'>
                                <p>A Supportive <br />Community</p>
                                <h1>4</h1>
                            </div>
                            <div className='para'>
                                Join a network of like-minded individuals
                                who are passionate about helping each
                                other achieve success.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
}
